var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0833 3.75002L30.1 10.1834L35.95 13.1667L33 19L35.9667 24.8334L30.0667 27.8167L29.05 34.25L22.5667 33.2334L17.95 37.8334L13.3167 33.1667L6.88332 34.2334L5.84999 27.75L0.0333252 24.7834L2.99999 18.95L0.0499918 13.1667L5.89999 10.15L6.91666 3.76669L13.3667 4.83336L18 0.150024L22.6167 4.76669L29.0833 3.75002ZM13.8333 10.6667C13.1703 10.6667 12.5344 10.9301 12.0656 11.3989C11.5967 11.8678 11.3333 12.5036 11.3333 13.1667C11.3333 13.8297 11.5967 14.4656 12.0656 14.9345C12.5344 15.4033 13.1703 15.6667 13.8333 15.6667C14.4964 15.6667 15.1323 15.4033 15.6011 14.9345C16.0699 14.4656 16.3333 13.8297 16.3333 13.1667C16.3333 12.5036 16.0699 11.8678 15.6011 11.3989C15.1323 10.9301 14.4964 10.6667 13.8333 10.6667ZM22.1667 22.3334C21.5036 22.3334 20.8677 22.5968 20.3989 23.0656C19.93 23.5344 19.6667 24.1703 19.6667 24.8334C19.6667 25.4964 19.93 26.1323 20.3989 26.6011C20.8677 27.07 21.5036 27.3334 22.1667 27.3334C22.8297 27.3334 23.4656 27.07 23.9344 26.6011C24.4033 26.1323 24.6667 25.4964 24.6667 24.8334C24.6667 24.1703 24.4033 23.5344 23.9344 23.0656C23.4656 22.5968 22.8297 22.3334 22.1667 22.3334ZM12.0167 27.3334L26.3333 13.0167L23.9833 10.6667L9.66666 24.9834L12.0167 27.3334Z",
    fill: "#A9CF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD1);
export default __webpack_public_path__ + "static/media/d-1.3be98556c4eaea46cad747ba0447cc3b.svg";
export { ForwardRef as ReactComponent };